var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c("div", {
      staticClass: "ban",
      staticStyle: {
        "background-image":
          "url('/images/ba0c1eb35598ad0d34d9ae0c732651fa.jpg')",
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "wp" }, [
      _c("div", { staticClass: "g-top" }, [
        _c("div", { staticClass: "cur" }, [
          _vm._v("\n        当前位置：\n        "),
          _c("a", { attrs: { href: "/" } }, [_vm._v("首页")]),
          _vm._v(">\n        "),
          _c("a", { attrs: { href: "javascript:void(0)" } }, [
            _vm._v("搜索结果"),
          ]),
          _vm._v(" >\n        "),
          _c("span", [_vm._v(_vm._s(_vm.$route.query.keyword))]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "g-content" },
        [
          _vm._l(_vm.resultList, function (item, index) {
            return _vm.resultList.length != 0
              ? _c(
                  "div",
                  {
                    key: index,
                    staticClass: "g-item",
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(item)
                      },
                    },
                  },
                  [_c("h3", [_vm._v(_vm._s(item.chipNameCn))])]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm.resultList.length == 0
            ? _c("div", { staticClass: "g-none" }, [_vm._v("暂无数据")])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }